import { Component, inject, Input, OnInit } from '@angular/core';
import { GridColumnBase } from 'src/app/shared/classes/list/grid-column-base';
import { ExtensionDisplayType } from 'src/models/ts/extension-display-type.model';
import { ExtensionIconComponent } from '../../../ui/icon/extension-icon/extension-icon.component';
import { PwaService } from 'src/app/core/services/pwa/pwa.service';
import { IconComponent } from '../../../ui/icon/icon.component';
import { AsyncPipe } from '@angular/common';
import { KeepOfflineService } from 'src/app/core/services/keep-offline/keep-offline.service';
import { OfflineSyncType } from '../../cells/grid-cell-extension/grid-cell-extension.component';

@Component({
  selector: 'bizz-grid-group-header-extension',
  templateUrl: '../../cells/grid-cell-extension/grid-cell-extension.component.html',
  styleUrls: ['../../cells/grid-cell-extension/grid-cell-extension.component.scss'],
  standalone: true,
  imports: [
    ExtensionIconComponent,
    IconComponent,
    AsyncPipe
  ]
})
export class GridGroupHeaderExtensionComponent implements OnInit {

  @Input() public column: GridColumnBase;
  @Input() public value: string;
  public data: any;
  public state: any;
  public pwaService = inject(PwaService);
  public keepOfflineService = inject(KeepOfflineService);

  public ngOnInit(): void {
  }

  protected readonly ExtensionDisplayType = ExtensionDisplayType;
  protected readonly OfflineSyncType = OfflineSyncType;



}
